<template>
  <patient-layout>
    <patient-appointment-booking-slots></patient-appointment-booking-slots>
  </patient-layout>
</template>

<script>
import PatientLayout from '@router/layouts/patient.vue'
import PatientAppointmentBookingSlots from '@components/appointment/booking/slots/Slots.vue'

export default {
  components: {
    PatientLayout,
    PatientAppointmentBookingSlots
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped></style>
